export const uploadLogo = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.279 17.1398C23.9002 17.1398 23.537 17.2903 23.2691 17.5583C23.0013 17.8263 22.8508 18.1897 22.8508 18.5687V19.1117L20.7371 16.9969C19.9908 16.2561 18.9821 15.8404 17.9308 15.8404C16.8794 15.8404 15.8707 16.2561 15.1244 16.9969L14.1247 17.9972L10.5828 14.4535C9.82603 13.7327 8.82123 13.3307 7.77642 13.3307C6.73162 13.3307 5.72682 13.7327 4.97006 14.4535L2.85635 16.5682V8.56634C2.85635 8.18737 3.00682 7.82392 3.27466 7.55595C3.54249 7.28797 3.90576 7.13743 4.28453 7.13743H14.2818C14.6605 7.13743 15.0238 6.98688 15.2916 6.71891C15.5595 6.45094 15.7099 6.08749 15.7099 5.70852C15.7099 5.32955 15.5595 4.9661 15.2916 4.69813C15.0238 4.43015 14.6605 4.27961 14.2818 4.27961H4.28453C3.1482 4.27961 2.05842 4.73124 1.25491 5.53516C0.451405 6.33908 0 7.42943 0 8.56634V25.7133C0 26.8502 0.451405 27.9405 1.25491 28.7444C2.05842 29.5484 3.1482 30 4.28453 30H21.4227C22.559 30 23.6488 29.5484 24.4523 28.7444C25.2558 27.9405 25.7072 26.8502 25.7072 25.7133V18.5687C25.7072 18.1897 25.5567 17.8263 25.2889 17.5583C25.0211 17.2903 24.6578 17.1398 24.279 17.1398ZM4.28453 27.1422C3.90576 27.1422 3.54249 26.9916 3.27466 26.7237C3.00682 26.4557 2.85635 26.0922 2.85635 25.7133V20.6121L6.99807 16.4682C7.20788 16.2682 7.4866 16.1566 7.77642 16.1566C8.06625 16.1566 8.34496 16.2682 8.55478 16.4682L13.0821 20.9979L19.2233 27.1422H4.28453ZM22.8508 25.7133C22.8488 25.9868 22.7586 26.2524 22.5938 26.4706L16.1527 19.9976L17.1524 18.9974C17.2548 18.8928 17.377 18.8098 17.5119 18.7531C17.6468 18.6964 17.7916 18.6671 17.9379 18.6671C18.0842 18.6671 18.229 18.6964 18.3639 18.7531C18.4988 18.8098 18.621 18.8928 18.7234 18.9974L22.8508 23.1555V25.7133ZM29.5775 4.69399L25.293 0.407259C25.1572 0.27717 24.997 0.175196 24.8217 0.107188C24.474 -0.0357292 24.084 -0.0357292 23.7363 0.107188C23.561 0.175196 23.4008 0.27717 23.265 0.407259L18.9805 4.69399C18.7115 4.96306 18.5605 5.328 18.5605 5.70852C18.5605 6.08904 18.7115 6.45397 18.9805 6.72304C19.2494 6.99211 19.6142 7.14327 19.9945 7.14327C20.3748 7.14327 20.7396 6.99211 21.0085 6.72304L22.8508 4.86546V12.8531C22.8508 13.232 23.0013 13.5955 23.2691 13.8635C23.537 14.1314 23.9002 14.282 24.279 14.282C24.6578 14.282 25.0211 14.1314 25.2889 13.8635C25.5567 13.5955 25.7072 13.232 25.7072 12.8531V4.86546L27.5495 6.72304C27.6823 6.85697 27.8403 6.96328 28.0143 7.03582C28.1883 7.10836 28.375 7.14571 28.5635 7.14571C28.7521 7.14571 28.9387 7.10836 29.1128 7.03582C29.2868 6.96328 29.4448 6.85697 29.5775 6.72304C29.7114 6.59021 29.8177 6.43217 29.8902 6.25804C29.9627 6.08392 30 5.89715 30 5.70852C30 5.51988 29.9627 5.33312 29.8902 5.15899C29.8177 4.98487 29.7114 4.82683 29.5775 4.69399Z"
      fill="#783AD0"
      fillOpacity="0.4"
    />
  </svg>
);

export const filterTick = (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.733398 4.13333L4.0334 7.43333L10.2667 1.2"
      stroke="#23BBB8"
      stroke-linecap="square"
    />
  </svg>
);

export const listViewIcon = (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1H22M1 6.33333H22M1 11.6667H22M1 17H22"
      stroke="#6B727A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const gridViewIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.96094 2.34375H3.32031C2.78097 2.34375 2.34375 2.78097 2.34375 3.32031V9.96094C2.34375 10.5003 2.78097 10.9375 3.32031 10.9375H9.96094C10.5003 10.9375 10.9375 10.5003 10.9375 9.96094V3.32031C10.9375 2.78097 10.5003 2.34375 9.96094 2.34375Z"
      stroke="#6B727A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.6797 2.34375H15.0391C14.4997 2.34375 14.0625 2.78097 14.0625 3.32031V9.96094C14.0625 10.5003 14.4997 10.9375 15.0391 10.9375H21.6797C22.219 10.9375 22.6562 10.5003 22.6562 9.96094V3.32031C22.6562 2.78097 22.219 2.34375 21.6797 2.34375Z"
      stroke="#6B727A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.96094 14.0625H3.32031C2.78097 14.0625 2.34375 14.4997 2.34375 15.0391V21.6797C2.34375 22.219 2.78097 22.6562 3.32031 22.6562H9.96094C10.5003 22.6562 10.9375 22.219 10.9375 21.6797V15.0391C10.9375 14.4997 10.5003 14.0625 9.96094 14.0625Z"
      stroke="#6B727A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.6797 14.0625H15.0391C14.4997 14.0625 14.0625 14.4997 14.0625 15.0391V21.6797C14.0625 22.219 14.4997 22.6562 15.0391 22.6562H21.6797C22.219 22.6562 22.6562 22.219 22.6562 21.6797V15.0391C22.6562 14.4997 22.219 14.0625 21.6797 14.0625Z"
      stroke="#6B727A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const apiIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_37_415)">
      <path
        d="M0.854492 17.5L7.29158 11.0629L9.35366 13.125L4.97866 17.5L9.35366 21.875L7.29158 23.9371L0.854492 17.5ZM11.0628 7.29164L17.4999 0.854553L23.937 7.29164L21.8749 9.35372L17.4999 4.97872L13.1249 9.35372L11.0628 7.29164ZM13.1249 25.6462L17.4999 30.0212L21.8749 25.6462L23.937 27.7083L17.4999 34.1454L11.0628 27.7083L13.1249 25.6462ZM16.0387 18.9612V16.0387H18.9612V18.9612H16.0387ZM25.6462 21.875L30.0212 17.5L25.6462 13.125L27.7082 11.0629L34.1453 17.5L27.7082 23.9371L25.6462 21.875Z"
        fill="#6FD1C7"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_415">
        <rect width="35" height="35" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const apiIcon2 = (
  <svg
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_37_424)">
      <path
        d="M38.5 33L33 38.5L27.5 33L33 27.5L38.5 33ZM33 16.5L38.83 22.33L45.705 15.455L33 2.75L20.295 15.455L27.17 22.33L33 16.5ZM16.5 33L22.33 27.17L15.455 20.295L2.75 33L15.455 45.705L22.33 38.83L16.5 33ZM49.5 33L43.67 38.83L50.545 45.705L63.25 33L50.545 20.295L43.67 27.17L49.5 33ZM33 49.5L27.17 43.67L20.295 50.545L33 63.25L45.705 50.545L38.83 43.67L33 49.5Z"
        fill="#6FD1C7"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_424">
        <rect width="66" height="66" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const apiCopyIcon = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.8421 0H1.26316C0.568421 0 0 0.572727 0 1.27273V10.1818H1.26316V1.27273H8.8421V0ZM10.7368 2.54545H3.78947C3.09474 2.54545 2.52632 3.11818 2.52632 3.81818V12.7273C2.52632 13.4273 3.09474 14 3.78947 14H10.7368C11.4316 14 12 13.4273 12 12.7273V3.81818C12 3.11818 11.4316 2.54545 10.7368 2.54545ZM10.7368 12.7273H3.78947V3.81818H10.7368V12.7273Z"
      fill="#783AD0"
    />
  </svg>
);

export const homeIcon = (
  <svg
    width="33"
    height="35"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.375 7.12516L9.5 1.5835L16.625 7.12516V15.8335C16.625 16.2534 16.4582 16.6561 16.1613 16.9531C15.8643 17.25 15.4616 17.4168 15.0417 17.4168H3.95833C3.53841 17.4168 3.13568 17.25 2.83875 16.9531C2.54181 16.6561 2.375 16.2534 2.375 15.8335V7.12516Z"
      stroke="#783AD0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.125 17.4167V9.5H11.875V17.4167"
      stroke="#783AD0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const downloadIcon = (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9.66667V1M8 9.66667L5.2 6.77778M8 9.66667L10.8 6.77778M1 11.1111L1.4347 12.9058C1.51041 13.2183 1.68518 13.4957 1.93123 13.694C2.17729 13.8922 2.48051 14 2.7927 14H13.2073C13.5195 14 13.8227 13.8922 14.0688 13.694C14.3148 13.4957 14.4896 13.2183 14.5653 12.9058L15 11.1111"
      stroke="#783AD0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const downloadIconbanner = (
  <svg
    width="29"
    height="27"
    viewBox="0 0 29 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 17.3333V2M14.5 17.3333L9.5 12.2222M14.5 17.3333L19.5 12.2222M2 19.8889L2.77625 23.0642C2.91144 23.617 3.22353 24.1078 3.66291 24.4586C4.1023 24.8094 4.64376 24.9999 5.20125 25H23.7987C24.3562 24.9999 24.8977 24.8094 25.3371 24.4586C25.7765 24.1078 26.0886 23.617 26.2237 23.0642L27 19.8889"
      stroke="#783AD0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DraftCampaignIcon = (
  <svg
    width="128"
    height="107"
    viewBox="0 0 128 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2 73.5625V71.5625H19.2H12.8C6.94648 71.5625 2 66.5229 2 60.1875V46.8125C2 40.4771 6.94648 35.4375 12.8 35.4375H38.4H38.9751L39.4624 35.132L68.4 16.9895V90.0105L39.4624 71.868L38.9751 71.5625H38.4H32H30V73.5625V98.3125H21.2V73.5625ZM126 58.1875H104.4V48.8125H126V58.1875ZM97.6977 83.1187C99.2055 84.301 100.799 85.5507 102.432 86.8318C106.617 90.1155 111.066 93.6051 115.013 96.6915C114.106 97.9537 113.199 99.221 112.293 100.486C111.419 101.709 110.546 102.929 109.673 104.143C108.312 103.08 106.892 101.968 105.445 100.836C101.045 97.3918 96.3882 93.7471 92.3522 90.6181C94.1354 88.1365 95.9178 85.6284 97.6977 83.1187ZM102.447 20.17C100.806 21.4526 99.2035 22.7044 97.686 23.8918C96.8139 22.6784 95.9413 21.4587 95.0672 20.2371L95.0665 20.2362C94.1607 18.9702 93.2534 17.7021 92.3454 16.4392C93.8976 15.2222 95.5413 13.9327 97.227 12.6102C101.367 9.36238 105.76 5.91583 109.673 2.85654C110.546 4.07087 111.419 5.29135 112.293 6.5138L112.296 6.51673C113.202 7.78378 114.11 9.05296 115.019 10.317C111.076 13.4283 106.634 16.899 102.447 20.17ZM78.8 70.639V36.3296C82.3043 41.065 84.4 47.0303 84.4 53.5C84.4 59.9738 82.3021 65.9379 78.8 70.639Z"
      stroke="#23BBB8"
      strokeWidth="4"
    />
  </svg>
);

export const shareIcon = (
  <svg
    width="33"
    height="30"
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 21.2048C21.36 21.2048 20.34 21.6566 19.56 22.3645L8.865 16.1145C8.94 15.7681 9 15.4217 9 15.0602C9 14.6988 8.94 14.3524 8.865 14.006L19.44 7.81627C20.25 8.56928 21.315 9.03614 22.5 9.03614C24.99 9.03614 27 7.01807 27 4.51807C27 2.01807 24.99 0 22.5 0C20.01 0 18 2.01807 18 4.51807C18 4.87952 18.06 5.2259 18.135 5.57229L7.56 11.762C6.75 11.009 5.685 10.5422 4.5 10.5422C2.01 10.5422 0 12.5602 0 15.0602C0 17.5602 2.01 19.5783 4.5 19.5783C5.685 19.5783 6.75 19.1114 7.56 18.3584L18.24 24.6235C18.165 24.9398 18.12 25.2711 18.12 25.6024C18.12 28.0271 20.085 30 22.5 30C24.915 30 26.88 28.0271 26.88 25.6024C26.88 23.1777 24.915 21.2048 22.5 21.2048ZM22.5 3.01205C23.325 3.01205 24 3.68976 24 4.51807C24 5.34639 23.325 6.0241 22.5 6.0241C21.675 6.0241 21 5.34639 21 4.51807C21 3.68976 21.675 3.01205 22.5 3.01205ZM4.5 16.5663C3.675 16.5663 3 15.8886 3 15.0602C3 14.2319 3.675 13.5542 4.5 13.5542C5.325 13.5542 6 14.2319 6 15.0602C6 15.8886 5.325 16.5663 4.5 16.5663ZM22.5 27.1386C21.675 27.1386 21 26.4608 21 25.6325C21 24.8042 21.675 24.1265 22.5 24.1265C23.325 24.1265 24 24.8042 24 25.6325C24 26.4608 23.325 27.1386 22.5 27.1386Z"
      fill="#783AD0"
    />
  </svg>
);
export const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="21"
    viewBox="0 0 11 13"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M8.10526 0H1.15789C0.521053 0 0 0.531818 0 1.18182V9.45455H1.15789V1.18182H8.10526V0ZM9.8421 2.36364H3.47368C2.83684 2.36364 2.31579 2.89545 2.31579 3.54545V11.8182C2.31579 12.4682 2.83684 13 3.47368 13H9.8421C10.4789 13 11 12.4682 11 11.8182V3.54545C11 2.89545 10.4789 2.36364 9.8421 2.36364ZM9.8421 11.8182H3.47368V3.54545H9.8421V11.8182Z"
      fill="#783AD0"
    />
  </svg>
);
export const copyIconSteps = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 11 13"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M8.10526 0H1.15789C0.521053 0 0 0.531818 0 1.18182V9.45455H1.15789V1.18182H8.10526V0ZM9.8421 2.36364H3.47368C2.83684 2.36364 2.31579 2.89545 2.31579 3.54545V11.8182C2.31579 12.4682 2.83684 13 3.47368 13H9.8421C10.4789 13 11 12.4682 11 11.8182V3.54545C11 2.89545 10.4789 2.36364 9.8421 2.36364ZM9.8421 11.8182H3.47368V3.54545H9.8421V11.8182Z"
      fill="#783AD0"
    />
  </svg>
);

export const qrCodeIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2256_32569)">
      <path
        d="M7.5 0H0V7.5H7.5V0ZM6.25 6.25H1.25V1.25H6.25V6.25Z"
        fill="#783AD0"
      />
      <path
        d="M2.5 2.5H5V5H2.5V2.5ZM0 20H7.5V12.5H0V20ZM1.25 13.75H6.25V18.75H1.25V13.75Z"
        fill="#783AD0"
      />
      <path
        d="M2.5 15H5V17.5H2.5V15ZM12.5 0V7.5H20V0H12.5ZM18.75 6.25H13.75V1.25H18.75V6.25Z"
        fill="#783AD0"
      />
      <path
        d="M15 2.5H17.5V5H15V2.5ZM2.5 8.75H0V11.25H3.75V10H2.5V8.75ZM8.75 11.25H11.25V13.75H8.75V11.25ZM3.75 8.75H6.25V10H3.75V8.75ZM11.25 15H8.75V16.25H10V17.5H11.25V16.25V15ZM7.5 8.75V10H6.25V11.25H8.75V8.75H7.5ZM10 5H11.25V7.5H10V5ZM11.25 10V11.25H13.75V8.75H10V10H11.25ZM8.75 7.5H10V8.75H8.75V7.5ZM11.25 17.5H13.75V20H11.25V17.5ZM8.75 17.5H10V20H8.75V17.5ZM11.25 13.75H12.5V15H11.25V13.75ZM11.25 3.75V1.25H10V0H8.75V5H10V3.75H11.25ZM15 17.5H16.25V20H15V17.5ZM15 15H17.5V16.25H15V15ZM13.75 16.25H15V17.5H13.75V16.25ZM12.5 15H13.75V16.25H12.5V15ZM17.5 12.5V13.75H18.75V15H20V12.5H18.75H17.5ZM18.75 16.25H17.5V20H20V17.5H18.75V16.25ZM12.5 12.5V13.75H16.25V11.25H13.75V12.5H12.5ZM15 8.75V10H17.5V11.25H20V8.75H17.5H15Z"
        fill="#783AD0"
      />
    </g>
    <defs>
      <clipPath id="clip0_2256_32569">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const modalCrossIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4635 6L6.09082 18"
      stroke="#333333"
      // stroke-width="2"
      // stroke-linecap="round"
      // stroke-linejoin="round"
    />
    <path
      d="M6.09114 6L17.4639 18"
      stroke="#333333"
      // stroke-width="2"
      // stroke-linecap="round"
      // stroke-linejoin="round"
    />
  </svg>
);

export const modalEditIcon = (
  <svg
    width="45"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.0833 17.5C32.0833 17.1132 32.237 16.7423 32.5105 16.4688C32.784 16.1953 33.1549 16.0417 33.5417 16.0417C33.9284 16.0417 34.2994 16.1953 34.5729 16.4688C34.8464 16.7423 35 17.1132 35 17.5V33.5417C35 33.9284 34.8464 34.2994 34.5729 34.5729C34.2994 34.8464 33.9284 35 33.5417 35H1.45833C1.07156 35 0.700627 34.8464 0.427136 34.5729C0.153646 34.2994 0 33.9284 0 33.5417V1.45833C0 1.07156 0.153646 0.700627 0.427136 0.427136C0.700627 0.153646 1.07156 0 1.45833 0H17.5C17.8868 0 18.2577 0.153646 18.5312 0.427136C18.8047 0.700627 18.9583 1.07156 18.9583 1.45833C18.9583 1.84511 18.8047 2.21604 18.5312 2.48953C18.2577 2.76302 17.8868 2.91667 17.5 2.91667H2.91667V32.0833H32.0833V17.5Z"
      fill="#3FD6C9"
    />
    <g transform="translate(15, 0) scale(1)">
      <path
        d="M3.0815 19.9155L5.41581 19.5816L19.7555 5.24382C19.8906 5.11331 19.9984 4.95719 20.0726 4.78458C20.1467 4.61196 20.1857 4.42631 20.1874 4.23845C20.189 4.0506 20.1532 3.86429 20.0821 3.69042C20.0109 3.51654 19.9059 3.35857 19.773 3.22573C19.6402 3.09289 19.4823 2.98784 19.3084 2.9167C19.1345 2.84556 18.9482 2.80976 18.7604 2.8114C18.5725 2.81303 18.3869 2.85206 18.2143 2.92621C18.0417 3.00036 17.8856 3.10814 17.7551 3.24327L3.41255 17.581L3.07867 19.9155H3.0815ZM21.7559 1.23989C22.1503 1.63406 22.4632 2.10208 22.6767 2.61722C22.8901 3.13236 23 3.68451 23 4.24213C23 4.79975 22.8901 5.3519 22.6767 5.86704C22.4632 6.38218 22.1503 6.8502 21.7559 7.24437L7.08519 21.916C6.86885 22.1332 6.58784 22.2742 6.28445 22.3178L1.61584 22.9856C1.39827 23.0169 1.17641 22.997 0.967852 22.9276C0.759299 22.8581 0.569792 22.741 0.414365 22.5856C0.258938 22.4302 0.141866 22.2407 0.0724341 22.0321C0.00300233 21.8235 -0.0168792 21.6016 0.0143676 21.3841L0.68212 16.7152C0.72499 16.4121 0.864977 16.1311 1.08108 15.9144L15.7547 1.24272C16.5506 0.447006 17.6299 0 18.7553 0C19.8807 0 20.96 0.447006 21.7559 1.24272V1.23989Z"
        fill="#3FD6C9"
      />
    </g>
  </svg>
);

export const ImageSizeIcon = (
  <svg
    width="110"
    height="110"
    viewBox="0 0 110 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M103.125 11.7356L98.2644 6.875L6.875 98.2644L11.7356 103.125L18.6106 96.25H89.375C91.1975 96.2473 92.9446 95.5221 94.2333 94.2333C95.5221 92.9446 96.2473 91.1975 96.25 89.375V18.6106L103.125 11.7356ZM89.375 89.375H25.4856L52.2741 62.5866L60.4519 70.7644C61.7411 72.0532 63.4895 72.7773 65.3125 72.7773C67.1355 72.7773 68.8839 72.0532 70.1731 70.7644L75.625 65.3125L89.375 79.0522V89.375ZM89.375 69.3275L80.4856 60.4381C79.1964 59.1493 77.448 58.4252 75.625 58.4252C73.802 58.4252 72.0536 59.1493 70.7644 60.4381L65.3125 65.89L57.1416 57.7191L89.375 25.4856V69.3275ZM20.625 75.625V65.3125L37.8125 48.1353L42.5322 52.8584L47.3997 47.9909L42.6731 43.2644C41.3839 41.9755 39.6355 41.2515 37.8125 41.2515C35.9895 41.2515 34.2411 41.9755 32.9519 43.2644L20.625 55.5913V20.625H75.625V13.75H20.625C18.8022 13.7518 17.0546 14.4767 15.7657 15.7657C14.4767 17.0546 13.7518 18.8022 13.75 20.625V75.625H20.625Z"
      fill="#23BBB8"
    />
  </svg>
);

export const CalendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M3.125 10.25C3.125 8.36438 3.125 7.42157 3.71079 6.83579C4.29657 6.25 5.23938 6.25 7.125 6.25H17.875C19.7606 6.25 20.7034 6.25 21.2892 6.83579C21.875 7.42157 21.875 8.36438 21.875 10.25V10.4167H3.125V10.25Z"
      fill="#7E869E"
    />
    <rect
      x="3.125"
      y="6.25"
      width="18.75"
      height="15.625"
      rx="2"
      stroke="#E5E5E5"
    />
    <path d="M7.29199 3.125L7.29199 6.25" stroke="#E5E5E5" />
    <path d="M17.708 3.125L17.708 6.25" stroke="#E5E5E5" />
    <rect
      x="7.29199"
      y="12.5"
      width="4.16667"
      height="2.08333"
      rx="0.5"
      fill="#E5E5E5"
    />
    <rect
      x="7.29199"
      y="16.6666"
      width="4.16667"
      height="2.08333"
      rx="0.5"
      fill="#E5E5E5"
    />
    <rect
      x="13.542"
      y="12.5"
      width="4.16667"
      height="2.08333"
      rx="0.5"
      fill="#E5E5E5"
    />
    <rect
      x="13.542"
      y="16.6666"
      width="4.16667"
      height="2.08333"
      rx="0.5"
      fill="#E5E5E5"
    />
  </svg>
);
export const watchIcon = (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="23" height="22" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_1730_916"
          transform="matrix(0.00996377 0 0 0.0104167 0.0217391 0)"
        />
      </pattern>
      <image
        id="image0_1730_916"
        width="96"
        height="96"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const plusIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6106 8.11199L8.86219 8.11791L8.8681 0.362521C8.86458 0.265184 8.82347 0.173011 8.75343 0.105397C8.68338 0.0377825 8.58987 0 8.49255 0C8.39524 0 8.30172 0.0377825 8.23168 0.105397C8.16164 0.173011 8.12053 0.265184 8.117 0.362521L8.11109 8.1184L0.362194 8.12382C0.264946 8.12735 0.172855 8.16849 0.105302 8.2386C0.0377484 8.30871 0 8.40231 0 8.49971C0 8.59711 0.0377484 8.69071 0.105302 8.76082C0.172855 8.83093 0.264946 8.87208 0.362194 8.8756L8.1106 8.86969L8.10469 16.6251C8.10469 16.7256 8.14508 16.8223 8.21452 16.8903C8.26711 16.9427 8.33401 16.9784 8.4068 16.9928C8.47958 17.0073 8.55502 16.9998 8.62361 16.9715C8.6922 16.9431 8.75088 16.8951 8.79228 16.8335C8.83368 16.7719 8.85595 16.6993 8.85628 16.6251L8.86219 8.86969L16.6106 8.86377C16.6611 8.8656 16.7114 8.85723 16.7585 8.83916C16.8057 8.8211 16.8487 8.7937 16.8851 8.75862C16.9214 8.72353 16.9503 8.68148 16.9701 8.63496C16.9898 8.58844 17 8.53842 17 8.48788C17 8.43734 16.9898 8.38732 16.9701 8.3408C16.9503 8.29428 16.9214 8.25223 16.8851 8.21714C16.8487 8.18206 16.8057 8.15466 16.7585 8.1366C16.7114 8.11853 16.6611 8.11016 16.6106 8.11199Z"
      fill="#783AD0"
    />
  </svg>
);

export const EmbedIcon = (
  <svg
    width="93"
    height="93"
    viewBox="0 0 93 93"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.1504 55.4687L57.9754 59.3125L70.7254 46.5L57.9754 33.6875L54.1504 37.5312L63.0754 46.5L54.1504 55.4687ZM38.8504 37.5312L35.0254 33.6875L22.2754 46.5L35.0254 59.3125L38.8504 55.4687L29.9254 46.5L38.8504 37.5312ZM48.9433 32.027L51.71 32.7855L44.06 60.973L41.2933 60.2145L48.9433 32.027Z"
      fill="black"
    />
    <circle cx="46.5" cy="46.5" r="45.5" stroke="black" />
  </svg>
);
export const facebookIcon = (
  <svg
    width="92"
    height="92"
    viewBox="0 0 92 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="45.8333" cy="45.8333" r="45.8333" fill="#3B5998" />
    <path
      d="M58.0136 29.695C56.5851 29.4093 54.6559 29.1958 53.4425 29.1958C50.157 29.1958 49.9436 30.6243 49.9436 32.9099V36.9785H58.1565L57.4405 45.4065H49.9436V71.0417H39.6603V45.4065H34.375V36.9785H39.6603V31.7654C39.6603 24.6247 43.0164 20.625 51.4427 20.625C54.3702 20.625 56.5129 21.0535 59.2976 21.6249L58.0136 29.695Z"
      fill="white"
    />
  </svg>
);

export const instagramIcon = (
  <svg
    width="92"
    height="92"
    viewBox="0 0 92 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="46" cy="46" r="46" fill="#C13584" />
    <path
      d="M46.0004 23.373C53.3699 23.373 54.2428 23.4011 57.1532 23.5339C59.8441 23.6566 61.3055 24.1062 62.2781 24.4842C63.5664 24.9849 64.4858 25.583 65.4515 26.5487C66.4174 27.5146 67.0155 28.434 67.5162 29.7223C67.8941 30.6948 68.3438 32.1562 68.4665 34.8472C68.5993 37.7575 68.6274 38.6305 68.6274 45.9999C68.6274 53.3694 68.5993 54.2424 68.4665 57.1527C68.3438 59.8436 67.8941 61.305 67.5162 62.2776C67.0155 63.5658 66.4174 64.4853 65.4517 65.451C64.4858 66.4169 63.5664 67.015 62.2781 67.5156C61.3055 67.8936 59.8441 68.3432 57.1532 68.4659C54.2433 68.5987 53.3704 68.6269 46.0004 68.6269C38.6303 68.6269 37.7576 68.5987 34.8476 68.4659C32.1566 68.3432 30.6952 67.8936 29.7227 67.5156C28.4344 67.015 27.515 66.4169 26.5492 65.451C25.5835 64.4853 24.9853 63.5658 24.4846 62.2776C24.1066 61.305 23.657 59.8436 23.5343 57.1527C23.4015 54.2424 23.3734 53.3694 23.3734 45.9999C23.3734 38.6305 23.4015 37.7575 23.5343 34.8472C23.657 32.1562 24.1066 30.6948 24.4846 29.7223C24.9853 28.434 25.5834 27.5146 26.5492 26.5488C27.515 25.583 28.4344 24.9849 29.7227 24.4842C30.6952 24.1062 32.1566 23.6566 34.8476 23.5339C37.7579 23.4011 38.6309 23.373 46.0004 23.373ZM46.0004 18.4C38.5047 18.4 37.5648 18.4318 34.6209 18.5661C31.6832 18.7001 29.6769 19.1667 27.9213 19.8489C26.1064 20.5543 24.5672 21.498 23.0327 23.0324C21.4984 24.5668 20.5546 26.106 19.8494 27.9209C19.1671 29.6765 18.7005 31.6828 18.5665 34.6205C18.4322 37.5643 18.4004 38.5042 18.4004 45.9999C18.4004 53.4956 18.4322 54.4355 18.5665 57.3793C18.7005 60.317 19.1671 62.3234 19.8494 64.0789C20.5546 65.8938 21.4984 67.433 23.0327 68.9675C24.5672 70.5019 26.1064 71.4456 27.9213 72.1508C29.6769 72.8331 31.6832 73.2997 34.6209 73.4337C37.5648 73.5681 38.5047 73.5998 46.0004 73.5998C53.4961 73.5998 54.436 73.5681 57.3798 73.4337C60.3175 73.2997 62.3239 72.8331 64.0794 72.1508C65.8944 71.4456 67.4336 70.5019 68.968 68.9675C70.5024 67.433 71.4461 65.8938 72.1515 64.0789C72.8337 62.3234 73.3003 60.317 73.4343 57.3793C73.5686 54.4355 73.6004 53.4956 73.6004 45.9999C73.6004 38.5042 73.5686 37.5643 73.4343 34.6205C73.3003 31.6828 72.8337 29.6765 72.1515 27.9209C71.4461 26.106 70.5024 24.5668 68.968 23.0324C67.4336 21.498 65.8944 20.5543 64.0794 19.8489C62.3239 19.1667 60.3175 18.7001 57.3798 18.5661C54.436 18.4318 53.4961 18.4 46.0004 18.4Z"
      fill="white"
    />
    <path
      d="M46.009 31.8398C38.1813 31.8398 31.8359 38.1852 31.8359 46.0127C31.8359 53.8403 38.1813 60.1857 46.009 60.1857C53.8365 60.1857 60.1819 53.8403 60.1819 46.0127C60.1819 38.1852 53.8365 31.8398 46.009 31.8398ZM46.009 55.2127C40.9279 55.2127 36.8089 51.0938 36.8089 46.0127C36.8089 40.9317 40.9279 36.8128 46.009 36.8128C51.09 36.8128 55.2089 40.9317 55.2089 46.0127C55.2089 51.0938 51.09 55.2127 46.009 55.2127Z"
      fill="white"
    />
    <path
      d="M64.0537 31.2712C64.0537 33.1002 62.5708 34.5831 60.7416 34.5831C58.9126 34.5831 57.4297 33.1002 57.4297 31.2712C57.4297 29.442 58.9126 27.9591 60.7416 27.9591C62.5708 27.9591 64.0537 29.442 64.0537 31.2712Z"
      fill="white"
    />
  </svg>
);
export const twitterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M18.0558 26.1029L0.912215 45.6712H8.50661L21.6288 30.6533L33.1916 45.6743L48 45.5936L29.2251 20.7665L45.2472 2.41357L37.7747 2.33L25.6722 16.1227L15.3177 2.35252L0 2.3359L18.0558 26.1029ZM39.0315 41.1668L35.1992 41.1549L8.8696 6.68497H12.9919L39.0315 41.1668Z"
      fill="white"
    />
  </svg>
);

export const editIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 1.38737C21.998 1.20014 21.9255 1.027 21.7936 0.897149L21.094 0.2046C20.8162 -0.0702049 20.3643 -0.0671851 20.0895 0.20762C19.8922 0.403909 19.717 0.581073 19.5952 0.703879L21.2964 2.38693C21.4182 2.26312 21.5933 2.08596 21.7896 1.88967C21.9255 1.75478 22 1.57561 22 1.38737ZM0 4.93598V19.3688C0 20.8213 1.17774 22.0041 2.62424 22.0041H17.0057C18.4522 22.0041 19.6289 20.8213 19.6289 19.3688V7.3458L18.2146 8.75405V19.3688C18.2146 20.0392 17.6721 20.5838 17.0057 20.5838H2.62424C1.95685 20.5838 1.41429 20.0392 1.41429 19.3688V4.93598C1.41429 4.26658 1.95685 3.722 2.62424 3.722H13.4242L14.8515 2.30067H2.62424C1.17774 2.30067 0 3.48344 0 4.93598ZM8.76849 11.4888L8.15647 13.7688L10.4707 13.1678L20.7975 2.87725L19.0993 1.19319L8.76849 11.4888Z"
      fill="#783AD0"
    />
  </svg>
);

export const timeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3832 18.6168 0 12 0ZM12 21.6C6.7068 21.6 2.4 17.2932 2.4 12C2.4 6.7068 6.7068 2.4 12 2.4C17.2932 2.4 21.6 6.7068 21.6 12C21.6 17.2932 17.2932 21.6 12 21.6Z"
      fill="#6B727A"
    />
    <path
      d="M12.9321 5.33337H10.666V11.9659L14.3972 16L15.9993 14.2678L12.9321 10.9515V5.33337Z"
      fill="#6B727A"
    />
  </svg>
);
export const PlatformSubmit = (
  <svg
    width="29"
    height="23"
    viewBox="0 0 29 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.875 1.25H5.125C4.11528 1.25 3.17147 1.56298 2.46416 2.10053C1.75707 2.63792 1.25 3.43525 1.25 4.375V18.625C1.25 19.5647 1.75707 20.3621 2.46416 20.8995C3.17147 21.437 4.11528 21.75 5.125 21.75H23.875C24.8847 21.75 25.8285 21.437 26.5358 20.8995C27.2429 20.3621 27.75 19.5647 27.75 18.625V4.375C27.75 3.43525 27.2429 2.63792 26.5358 2.10053C25.8285 1.56298 24.8847 1.25 23.875 1.25ZM19.2355 11.5L12.125 15.553V7.44703L19.2355 11.5Z"
      stroke="#6B727A"
      strokeWidth="1.5"
    />
  </svg>
);

export const timeLimiIcon = (
  <svg
    width="27"
    height="16"
    viewBox="0 0 27 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5625 16C16.5094 16 14.7161 15.3936 13.1828 14.1808C11.6505 12.9669 10.6875 11.44 10.2938 9.6H0V6.4H10.2938C10.4344 5.78667 10.6245 5.21333 10.8641 4.68C11.1026 4.14667 11.4187 3.65333 11.8125 3.2H3.375V0H18.5625C20.8969 0 22.887 0.779733 24.5329 2.3392C26.1776 3.89973 27 5.78667 27 8C27 10.2133 26.1776 12.0997 24.5329 13.6592C22.887 15.2197 20.8969 16 18.5625 16ZM18.5625 12.8C19.9688 12.8 21.1641 12.3333 22.1484 11.4C23.1328 10.4667 23.625 9.33333 23.625 8C23.625 6.66667 23.1328 5.53333 22.1484 4.6C21.1641 3.66667 19.9688 3.2 18.5625 3.2C17.1562 3.2 15.9609 3.66667 14.9766 4.6C13.9922 5.53333 13.5 6.66667 13.5 8C13.5 9.33333 13.9922 10.4667 14.9766 11.4C15.9609 12.3333 17.1562 12.8 18.5625 12.8ZM5.0625 16V12.8H10.125V16H5.0625Z"
      fill="#6B727A"
    />
  </svg>
);

export const updatedCampaignIcon = (
  <svg
    width="81"
    height="71"
    viewBox="0 0 81 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.65 48.8125V47.3125H12.15H8.1C4.59948 47.3125 1.5 44.1223 1.5 39.9375V31.0625C1.5 26.8777 4.59948 23.6875 8.1 23.6875H24.3H24.7489L25.124 23.4409L43.05 11.6562V59.3438L25.124 47.5591L24.7489 47.3125H24.3H20.25H18.75V48.8125V65.0625H13.65V48.8125ZM79.5 38.4375H66.3V32.5625H79.5V38.4375ZM61.8799 55.4547C62.7664 56.1836 63.6968 56.949 64.6486 57.7319C67.2597 59.8798 70.0322 62.1604 72.5033 64.1866C71.9535 64.9889 71.4041 65.794 70.8557 66.5977L70.851 66.6045C70.3492 67.3398 69.8483 68.0739 69.3478 68.8047C68.5563 68.1557 67.7351 67.4818 66.8992 66.7957C64.1537 64.5426 61.2498 62.1593 58.7203 60.1024C59.7743 58.5636 60.8279 57.0098 61.8799 55.4547ZM64.6594 13.2686C63.7015 14.0534 62.7646 14.8209 61.8714 15.5536C61.3712 14.8231 60.8705 14.0894 60.369 13.3545L60.3677 13.3525C59.8178 12.5467 59.2669 11.7394 58.7156 10.9349C59.6664 10.1532 60.6701 9.32759 61.6983 8.48173C64.2388 6.39198 66.9298 4.17838 69.3478 2.19528C69.8483 2.92613 70.3492 3.66019 70.851 4.39548L70.8539 4.39973C71.4043 5.2063 71.9557 6.01434 72.5075 6.8195C70.0394 8.86099 67.2711 11.129 64.6594 13.2686ZM50.1 46.1444V24.8388C52.0304 27.8396 53.175 31.5211 53.175 35.5C53.175 39.4816 52.029 43.1624 50.1 46.1444Z"
      stroke="#23BBB8"
      strokeWidth="3"
    />
  </svg>
);

export const calenderIcon = (
  <svg width="30" height="33" viewBox="0 0 33 33" fill="none">
    <path
      d="M4.125 12.25C4.125 10.3644 4.125 9.42157 4.71079 8.83579C5.29657 8.25 6.23938 8.25 8.125 8.25H24.875C26.7606 8.25 27.7034 8.25 28.2892 8.83579C28.875 9.42157 28.875 10.3644 28.875 12.25V13.75H4.125V12.25Z"
      fill="#333333"
      stroke="#333333"
    />
    <rect
      x="4.125"
      y="8.25"
      width="24.75"
      height="20.625"
      rx="2"
      stroke="#6B727A"
    />
    <path d="M9.625 4.125L9.625 8.25" stroke="#6B727A" />
    <path d="M23.375 4.125L23.375 8.25" stroke="#6B727A" />
    <rect
      x="9.625"
      y="16.5"
      width="5.5"
      height="2.75"
      rx="0.5"
      fill="#6B727A"
    />
    <rect x="9.625" y="22" width="5.5" height="2.75" rx="0.5" fill="#6B727A" />
    <rect
      x="17.875"
      y="16.5"
      width="5.5"
      height="2.75"
      rx="0.5"
      fill="#6B727A"
    />
    <rect x="17.875" y="22" width="5.5" height="2.75" rx="0.5" fill="#6B727A" />
  </svg>
);

export const rewardIcon = (
  <svg
    width="30"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1693 1.75614H7.64009C7.46475 2.59958 7.04166 3.37374 6.42334 3.98251C5.80503 4.59127 5.01873 5.00783 4.16206 5.18046C4.16172 5.43412 4.16172 5.68777 4.16206 5.94143C5.01873 6.11406 5.80503 6.53062 6.42334 7.13938C7.04166 7.74815 7.46475 8.52231 7.64009 9.36575H13.1693C13.3446 8.52231 13.7677 7.74815 14.386 7.13938C15.0043 6.53062 15.7906 6.11406 16.6473 5.94143C16.6475 5.68777 16.6475 5.43412 16.6473 5.18046C15.7906 5.00783 15.0043 4.59127 14.386 3.98251C13.7677 3.37374 13.3446 2.59958 13.1693 1.75614ZM13.8886 0.00358764C13.5617 7.55079e-05 13.2144 7.54833e-05 12.8446 7.54833e-05H7.9647C7.59609 7.54833e-05 7.24769 7.55079e-05 6.92189 0.00358764C6.85695 -0.00217159 6.79157 -0.000994003 6.72688 0.00709979C6.18942 0.0164655 5.71261 0.0387088 5.29881 0.0937321C4.55207 0.192072 3.87787 0.409824 3.33685 0.942497C2.79463 1.47634 2.57346 2.14013 2.47358 2.87417C2.4177 3.28274 2.3951 3.7522 2.38559 4.28136C2.37745 4.34466 2.37625 4.40864 2.38202 4.47219C2.37846 4.79413 2.37846 5.13715 2.37846 5.50007V5.62182C2.37846 5.98474 2.37846 6.32776 2.38202 6.6497C2.37626 6.71325 2.37746 6.77723 2.38559 6.84053C2.3951 7.37086 2.4177 7.83914 2.47358 8.24655C2.57346 8.98176 2.79463 9.64555 3.33685 10.1782C3.87787 10.7121 4.55207 10.9298 5.29881 11.0282C5.71261 11.0832 6.18942 11.1054 6.72688 11.1148C6.79156 11.123 6.85695 11.1242 6.92189 11.1183C7.24769 11.1218 7.59609 11.1218 7.9647 11.1218H12.8446C13.2133 11.1218 13.5617 11.1218 13.8886 11.1183C13.9532 11.1241 14.0182 11.1229 14.0825 11.1148C14.6211 11.1054 15.0979 11.0832 15.5105 11.0282C16.2573 10.9298 16.9315 10.7121 17.4725 10.1782C18.0147 9.64555 18.2359 8.98176 18.3358 8.24655C18.3921 7.7799 18.4215 7.31047 18.4238 6.84053C18.4318 6.77723 18.433 6.71326 18.4273 6.6497C18.4309 6.32776 18.4309 5.98474 18.4309 5.62182V5.50007C18.4309 5.13715 18.4309 4.79413 18.4273 4.47219C18.4332 4.40864 18.432 4.34465 18.4238 4.28136C18.4213 3.81143 18.3919 3.34201 18.3358 2.87534C18.2359 2.14013 18.0147 1.47634 17.4737 0.943667C16.9315 0.409824 16.2573 0.192072 15.5117 0.0937321C15.0373 0.038386 14.5602 0.00946255 14.0825 0.00709979C14.0182 -0.00094598 13.9532 -0.00212356 13.8886 0.00358764ZM15.0349 1.80765C15.1695 2.1579 15.3783 2.47597 15.6472 2.74077C15.9162 3.00558 16.2392 3.21107 16.595 3.34362C16.5875 3.2654 16.5784 3.18733 16.5676 3.10948C16.4951 2.56861 16.3667 2.33681 16.2109 2.18462C16.0563 2.03243 15.8221 1.90716 15.2739 1.83341C15.1948 1.82324 15.1155 1.81465 15.0361 1.80765M16.5962 7.77827C16.2404 7.91082 15.9174 8.11631 15.6484 8.38112C15.3794 8.64592 15.1707 8.96399 15.0361 9.31424C15.1193 9.30722 15.199 9.29785 15.2739 9.28848C15.8233 9.21473 16.0587 9.08946 16.2133 8.93727C16.3679 8.78508 16.4963 8.55328 16.57 8.01241C16.5795 7.93866 16.589 7.86022 16.5962 7.77827ZM5.77563 9.31424C5.64099 8.96399 5.43228 8.64592 5.16332 8.38112C4.89436 8.11631 4.57131 7.91082 4.21557 7.77827C4.22389 7.86022 4.23221 7.93866 4.24292 8.01241C4.31664 8.55328 4.44387 8.78508 4.59964 8.93727C4.75422 9.08946 4.98846 9.21473 5.53662 9.28848C5.61272 9.29785 5.69239 9.30722 5.77563 9.31424ZM4.21557 3.34362C4.57131 3.21107 4.89436 3.00558 5.16332 2.74077C5.43228 2.47597 5.64099 2.1579 5.77563 1.80765C5.69239 1.81467 5.61272 1.82404 5.53781 1.83458C4.98846 1.90716 4.75303 2.03243 4.59845 2.18579C4.44387 2.33798 4.31664 2.56861 4.24173 3.10831L4.21557 3.34362ZM10.4047 5.26827C10.3258 5.26827 10.2502 5.2991 10.1945 5.35399C10.1387 5.40888 10.1074 5.48332 10.1074 5.56095C10.1074 5.63857 10.1387 5.71301 10.1945 5.7679C10.2502 5.82279 10.3258 5.85362 10.4047 5.85362C10.4835 5.85362 10.5591 5.82279 10.6149 5.7679C10.6706 5.71301 10.7019 5.63857 10.7019 5.56095C10.7019 5.48332 10.6706 5.40888 10.6149 5.35399C10.5591 5.2991 10.4835 5.26827 10.4047 5.26827ZM8.3238 5.56095C8.3238 5.01758 8.54304 4.49648 8.93328 4.11227C9.32351 3.72805 9.85279 3.5122 10.4047 3.5122C10.9566 3.5122 11.4858 3.72805 11.8761 4.11227C12.2663 4.49648 12.4855 5.01758 12.4855 5.56095C12.4855 6.1043 12.2663 6.62541 11.8761 7.00962C11.4858 7.39384 10.9566 7.60969 10.4047 7.60969C9.85279 7.60969 9.32351 7.39384 8.93328 7.00962C8.54304 6.62541 8.3238 6.1043 8.3238 5.56095ZM6.46172 14.2804C8.68052 13.8578 11.0551 13.9526 12.9778 15.0812C13.2465 15.2392 13.501 15.437 13.721 15.6806C14.1681 16.1758 14.3988 16.7892 14.4095 17.405C14.6366 17.261 14.8649 17.1006 15.0956 16.9285L17.2454 15.3305C17.7838 14.9408 18.4345 14.7306 19.1027 14.7306C19.7709 14.7306 20.4217 14.9408 20.96 15.3305C21.9529 16.0681 22.3501 17.3945 21.6378 18.5184C21.1325 19.3156 20.3715 20.4196 19.5962 21.1267C18.8114 21.8408 17.6972 22.4426 16.8542 22.843C15.8292 23.33 14.7234 23.5992 13.6473 23.7702C11.4475 24.1214 9.15972 24.0675 6.9861 23.6262C5.86519 23.399 4.72382 23.2841 3.57942 23.2831H0.892119C0.655599 23.2831 0.428765 23.1906 0.26152 23.026C0.0942745 22.8613 0.000317147 22.638 0.000317147 22.4051C0.000317147 22.1722 0.0942745 21.9489 0.26152 21.7843C0.428765 21.6196 0.655599 21.5271 0.892119 21.5271H3.57942C4.84221 21.5271 6.11808 21.657 7.34639 21.9064C9.32757 22.3066 11.366 22.3507 13.3631 22.0363C14.3476 21.8795 15.268 21.6465 16.0789 21.2613C16.891 20.875 17.8043 20.3669 18.3833 19.8389C18.9695 19.3039 19.6247 18.3779 20.1253 17.5888C20.2763 17.35 20.2549 17.007 19.8851 16.7319C19.4452 16.4041 18.7591 16.4041 18.3203 16.7319L16.1717 18.3299C15.3132 18.9679 14.2573 19.6504 12.9481 19.8565C12.8109 19.8779 12.6734 19.8966 12.5355 19.9127C11.7023 20.0073 10.8614 20.0152 10.0266 19.9361C9.90788 19.928 9.79205 19.8966 9.68588 19.8438C9.57971 19.791 9.48534 19.7178 9.40833 19.6286C9.33132 19.5393 9.27323 19.4358 9.23747 19.3241C9.20171 19.2124 9.18902 19.0948 9.20012 18.9782C9.21123 18.8616 9.24591 18.7483 9.30214 18.6451C9.35837 18.5419 9.43499 18.4508 9.52751 18.3772C9.62003 18.3036 9.72658 18.249 9.84087 18.2165C9.95516 18.184 10.0749 18.1744 10.193 18.1882C10.8526 18.2513 11.517 18.2501 12.1764 18.1847L12.2121 18.1812C12.323 18.1134 12.4173 18.0222 12.4881 17.9142C12.5589 17.8062 12.6045 17.6841 12.6215 17.5566C12.6386 17.4292 12.6267 17.2996 12.5868 17.1772C12.5468 17.0548 12.4797 16.9427 12.3904 16.8489C12.2957 16.7462 12.1854 16.6586 12.0634 16.589C10.6591 15.7637 8.78278 15.6267 6.8006 16.0037C4.86451 16.3872 3.02908 17.1582 1.40818 18.269C1.31261 18.3357 1.20463 18.3833 1.09041 18.4089C0.976186 18.4345 0.857951 18.4378 0.742457 18.4184C0.626963 18.3991 0.51647 18.3575 0.417289 18.2961C0.318107 18.2347 0.232178 18.1547 0.164409 18.0606C0.0966393 17.9665 0.0483561 17.8602 0.0223162 17.7478C-0.00372377 17.6353 -0.00701064 17.5189 0.0126433 17.4052C0.0322972 17.2915 0.0745072 17.1827 0.136863 17.085C0.199218 16.9874 0.280499 16.9028 0.376063 16.836C2.20443 15.581 4.27619 14.711 6.46172 14.2804Z"
      fill="#6B727A"
    />
  </svg>
);

export const uploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="76"
    height="78"
    viewBox="0 0 76 78"
    fill="none"
  >
    <g filter="url(#filter0_dd_1715_1144)">
      <path
        d="M59.375 41.1667C58.5462 41.1667 57.7513 41.5003 57.1653 42.0942C56.5792 42.6881 56.25 43.4935 56.25 44.3334V45.5367L51.625 40.85C49.992 39.2083 47.7848 38.287 45.4844 38.287C43.184 38.287 40.9768 39.2083 39.3438 40.85L37.1563 43.0667L29.4063 35.2134C27.7504 33.6161 25.5518 32.7253 23.2656 32.7253C20.9795 32.7253 18.7809 33.6161 17.125 35.2134L12.5 39.9V22.1667C12.5 21.3269 12.8292 20.5214 13.4153 19.9275C14.0013 19.3337 14.7962 19 15.625 19H37.5C38.3288 19 39.1237 18.6664 39.7097 18.0725C40.2958 17.4787 40.625 16.6732 40.625 15.8334C40.625 14.9935 40.2958 14.1881 39.7097 13.5942C39.1237 13.0003 38.3288 12.6667 37.5 12.6667H15.625C13.1386 12.6667 10.754 13.6676 8.99587 15.4492C7.23772 17.2308 6.25 19.6471 6.25 22.1667V60.1667C6.25 62.6863 7.23772 65.1026 8.99587 66.8842C10.754 68.6658 13.1386 69.6667 15.625 69.6667H53.125C55.6114 69.6667 57.996 68.6658 59.7541 66.8842C61.5123 65.1026 62.5 62.6863 62.5 60.1667V44.3334C62.5 43.4935 62.1708 42.6881 61.5847 42.0942C60.9987 41.5003 60.2038 41.1667 59.375 41.1667ZM15.625 63.3334C14.7962 63.3334 14.0013 62.9997 13.4153 62.4059C12.8292 61.812 12.5 61.0066 12.5 60.1667V48.8617L21.5625 39.6784C22.0216 39.235 22.6315 38.9877 23.2656 38.9877C23.8998 38.9877 24.5097 39.235 24.9688 39.6784L34.875 49.7167L48.3125 63.3334H15.625ZM56.25 60.1667C56.2455 60.7729 56.0483 61.3615 55.6875 61.845L41.5938 47.5L43.7813 45.2834C44.0053 45.0517 44.2727 44.8676 44.5678 44.7419C44.863 44.6162 45.1799 44.5515 45.5 44.5515C45.8201 44.5515 46.137 44.6162 46.4322 44.7419C46.7273 44.8676 46.9947 45.0517 47.2188 45.2834L56.25 54.4984V60.1667ZM70.9688 13.585L61.5938 4.08504C61.2966 3.79674 60.9461 3.57075 60.5625 3.42004C59.8017 3.10331 58.9483 3.10331 58.1875 3.42004C57.8039 3.57075 57.4535 3.79674 57.1563 4.08504L47.7813 13.585C47.1928 14.1813 46.8622 14.9901 46.8622 15.8334C46.8622 16.6767 47.1928 17.4854 47.7813 18.0817C48.3697 18.678 49.1678 19.013 50 19.013C50.8322 19.013 51.6303 18.678 52.2188 18.0817L56.25 13.965V31.6667C56.25 32.5066 56.5792 33.312 57.1653 33.9059C57.7513 34.4997 58.5462 34.8334 59.375 34.8334C60.2038 34.8334 60.9987 34.4997 61.5847 33.9059C62.1708 33.312 62.5 32.5066 62.5 31.6667V13.965L66.5313 18.0817C66.8218 18.3785 67.1674 18.6141 67.5482 18.7749C67.929 18.9356 68.3375 19.0184 68.75 19.0184C69.1625 19.0184 69.571 18.9356 69.9518 18.7749C70.3326 18.6141 70.6782 18.3785 70.9688 18.0817C71.2617 17.7873 71.4941 17.4371 71.6528 17.0512C71.8114 16.6653 71.8931 16.2514 71.8931 15.8334C71.8931 15.4153 71.8114 15.0014 71.6528 14.6155C71.4941 14.2297 71.2617 13.8794 70.9688 13.585Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1715_1144"
        x="-4"
        y="0"
        width="83"
        height="84"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1715_1144"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1715_1144"
          result="effect2_dropShadow_1715_1144"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1715_1144"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const dropdownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
  >
    <path
      d="M6 7C6.23675 7 6.43968 6.91087 6.61556 6.7189L11.77 1.38492C11.9188 1.23408 12 1.04212 12 0.815866C12 0.363369 11.6483 0 11.195 0C10.9718 0 10.7756 0.095984 10.6201 0.246817L6 5.05289L1.37993 0.246817C1.22435 0.095984 1.02142 0 0.804961 0C0.351747 0 0 0.363369 0 0.815866C0 1.04212 0.0811725 1.23408 0.229989 1.38492L5.37768 6.7189C5.56032 6.91087 5.76325 7 6 7Z"
      fill="#C4C4C4"
    />
  </svg>
);

export const dropdownIconProduct = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="#6e6b7b"
  >
    <path
      d="M6 7C6.23675 7 6.43968 6.91087 6.61556 6.7189L11.77 1.38492C11.9188 1.23408 12 1.04212 12 0.815866C12 0.363369 11.6483 0 11.195 0C10.9718 0 10.7756 0.095984 10.6201 0.246817L6 5.05289L1.37993 0.246817C1.22435 0.095984 1.02142 0 0.804961 0C0.351747 0 0 0.363369 0 0.815866C0 1.04212 0.0811725 1.23408 0.229989 1.38492L5.37768 6.7189C5.56032 6.91087 5.76325 7 6 7Z"
      fill="#6e6b7b"
    />
  </svg>
);

export const tickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="15"
    width="15"
    viewBox="0 0 512 512"
  >
    <path
      fill="#9e9e9e"
      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 48c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m140.2 130.3l-22.5-22.7c-4.7-4.7-12.3-4.7-17-.1L215.3 303.7l-59.8-60.3c-4.7-4.7-12.3-4.7-17-.1l-22.7 22.5c-4.7 4.7-4.7 12.3-.1 17l90.8 91.5c4.7 4.7 12.3 4.7 17 .1l172.6-171.2c4.7-4.7 4.7-12.3 .1-17z"
    />
  </svg>
);

export const crossIcon = (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.0493 10.3472L10.3496 31.0416"
      stroke="#783AD0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3501 10.3472L31.0498 31.0416"
      stroke="#783AD0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const backIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="20"
    viewBox="0 0 10 20"
    fill="none"
  >
    <path
      d="M8.34077 19.9999C8.12731 20.0006 7.9164 19.9535 7.72354 19.8621C7.53068 19.7706 7.36076 19.6371 7.22628 19.4714L0.325041 10.9008C0.114887 10.6452 0 10.3246 0 9.9937C0 9.66284 0.114887 9.34224 0.325041 9.08665L7.46918 0.516026C7.71171 0.224316 8.06022 0.0408693 8.43804 0.00604443C8.81586 -0.0287805 9.19204 0.0878684 9.48383 0.330329C9.77562 0.57279 9.95912 0.921202 9.99395 1.29892C10.0288 1.67663 9.91211 2.05271 9.66958 2.34442L3.28272 10.0008L9.45526 17.6573C9.62998 17.8669 9.74096 18.1223 9.77508 18.393C9.8092 18.6638 9.76503 18.9386 9.64779 19.1851C9.53054 19.4315 9.34514 19.6392 9.11351 19.7836C8.88188 19.928 8.61372 20.0031 8.34077 19.9999Z"
      fill="#783AD0"
    />
  </svg>
);
export const dot = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <circle cx="6" cy="6" r="5.5" stroke="#6B727A" />
  </svg>
);

export const videoIcon = (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0.5H3C2.35134 0.5 1.74387 0.698346 1.2875 1.04062C0.831529 1.3826 0.5 1.89357 0.5 2.5V11.5C0.5 12.1064 0.831529 12.6174 1.2875 12.9594C1.74387 13.3017 2.35134 13.5 3 13.5H15C15.6487 13.5 16.2561 13.3017 16.7125 12.9594C17.1685 12.6174 17.5 12.1064 17.5 11.5V2.5C17.5 1.89357 17.1685 1.3826 16.7125 1.04062C16.2561 0.698346 15.6487 0.5 15 0.5ZM11.9801 7L7.5 9.52008V4.47992L11.9801 7Z"
      stroke="black"
    />
  </svg>
);

export const deleteIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_581_1411)">
      <path
        d="M12.9062 1.75H10.0625L9.14375 0.525C9.02149 0.361993 8.86297 0.229688 8.68072 0.138564C8.49847 0.0474404 8.29751 0 8.09375 0L5.90625 0C5.70249 0 5.50153 0.0474404 5.31928 0.138564C5.13703 0.229688 4.97851 0.361993 4.85625 0.525L3.9375 1.75H1.09375C1.03573 1.75 0.980094 1.77305 0.93907 1.81407C0.898047 1.85509 0.875 1.91073 0.875 1.96875V2.40625C0.875 2.46427 0.898047 2.51991 0.93907 2.56093C0.980094 2.60195 1.03573 2.625 1.09375 2.625H1.61055L2.51836 12.8051C2.54772 13.1315 2.69811 13.4351 2.93998 13.6562C3.18185 13.8773 3.49768 14 3.82539 14H10.1746C10.5023 14 10.8182 13.8773 11.06 13.6562C11.3019 13.4351 11.4523 13.1315 11.4816 12.8051L12.3895 2.625H12.9062C12.9643 2.625 13.0199 2.60195 13.0609 2.56093C13.102 2.51991 13.125 2.46427 13.125 2.40625V1.96875C13.125 1.91073 13.102 1.85509 13.0609 1.81407C13.0199 1.77305 12.9643 1.75 12.9062 1.75ZM5.55625 1.05C5.59715 0.995821 5.65002 0.951833 5.71074 0.921475C5.77145 0.891117 5.83837 0.875211 5.90625 0.875H8.09375C8.16163 0.875211 8.22855 0.891117 8.28926 0.921475C8.34998 0.951833 8.40285 0.995821 8.44375 1.05L8.96875 1.75H5.03125L5.55625 1.05ZM10.6094 12.7258C10.6004 12.8348 10.5506 12.9364 10.4701 13.0104C10.3895 13.0844 10.284 13.1253 10.1746 13.125H3.82539C3.716 13.1253 3.61052 13.0844 3.52995 13.0104C3.44937 12.9364 3.39963 12.8348 3.39062 12.7258L2.48828 2.625H11.5117L10.6094 12.7258Z"
        fill="#989898"
      />
    </g>
    <defs>
      <clipPath id="clip0_581_1411">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
